import React from "react";
import { compose } from "redux";
import classNames from "classnames";
import { Link } from "react-router-dom";
import { ButtonBase, withStyles } from "@material-ui/core";

const ViewHeaderIconButton = ({
  to,
  Icon,
  title,
  classes,
  selected,
  disabled,
  LinkProps,
  ButtonProps,
}) => {
  const Button = (
    <ButtonBase
      title={title}
      disabled={disabled}
      className={classNames(classes.root, {
        [classes.selected]: selected && !disabled,
      })}
      {...ButtonProps}
    >
      <Icon className={classes.icon} />
    </ButtonBase>
  );

  return to ? (
    <Link to={to} className={classes.link} {...LinkProps}>
      {Button}
    </Link>
  ) : (
    Button
  );
};

const styles = theme => ({
  root: {
    display: "block",
    fontSize: "1rem",
    fontWeight: 700,
    width: theme.spacing(6),
    height: theme.spacing(6),
    fontFamily: theme.typography.fontFamily,
    "&:hover": {
      background: theme.palette.primary.light,
    },
    "&.Mui-disabled": {
      opacity: 0.3,
    },
  },
  selected: {
    background: theme.palette.primary.light,
  },
  icon: {
    margin: "0 auto",
    display: "block",
    width: theme.altus.row.height,
    height: theme.altus.row.height,
  },
  link: {
    display: "contents",
    color: theme.palette.primary.contrastText,
  },
});

export default compose(withStyles(styles))(ViewHeaderIconButton);
